import { AuthenticationService } from '../../Login/_services/authentication.service';
import { AziendeStoreService } from '../../Admin/_service/aziende-store.service';
import { Azienda } from '../../Admin/models/Azienda';
import { SpedizioniStoreService } from '../_services/spedizioni-store.service';
import { ApiRestService } from '../_services/api-rest.service';
import { ApiRestService as AdminApiRestService } from './../../Admin/_service/api-rest.service';
import { Spedizione } from '../Models/Spedizione';
import {Component, Input, OnInit} from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Subscription } from 'rxjs';
import { Corriere } from '../Models/Corriere';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { RicercaPaginazione } from 'src/app/Admin/models/sendpersonale';
import { FileStoreService } from 'src/app/shared/_services/file-store.service';
import {DownloadService} from "../../shared/_services/download.service";
import {Permission} from "../../Login/_guards/Permission";
import {ClassicType} from "../../shared/models/ClassicType";
import {ToastrService} from "ngx-toastr";
import {AngularFileUploaderConfig} from "../../shared/file-uploader/angular-file-uploader.types";
import {HttpHeaders} from "@angular/common/http";
import {NgxSpinnerService} from "ngx-spinner";

@Component({
  selector: 'app-edit-spedizioni',
  templateUrl: './edit-spedizioni.component.html',
  styleUrls:['./edit-spedizioni.scss']
})
export class EditSpedizioniComponent implements OnInit {
  defaultNation: ClassicType[] = [{id: "IT", label: "Italia"}];
  corrieredropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    textField: 'nominativo',
    allowSearchFilter: false,
    allowRemoteDataSearch: false,
  };
  clientedropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    textField: 'nominativo',
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
    searchPlaceholderText: "inserisci Almeno 3 caratteri"
  };
  nazioniDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'label',
    allowSearchFilter: true,
    allowRemoteDataSearch: false,
    searchPlaceholderText: "Cerca"
  };
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'label',
  };
  corrieri: Corriere[] = [];
  clienti: Azienda[] = [];
  subscriptions: Subscription = new Subscription();
  Selected: Spedizione = new Spedizione();
  isAddable: boolean;
  isAdmin: boolean;
  isAgenziaMadre: boolean;
  totale: number = 0;
  spedid: string;
  nazioni: ClassicType[] = [];
  tariffe: any[] = [];
  tariffeSelezionate: ClassicType[] = [];
  Corrieri: any[] = [];
  @Input() Base64afuConfig: AngularFileUploaderConfig = {
    multiple: true,
    maxSize: 5,
    formatsAllowed: "pdf,doc,docx,xls,xlsx,jpg,png,txt,ods,odt",
    uploadAPI:  {
      url: "",
      method: "POST",
      headers: new HttpHeaders(),
      //responseType: 'application/json',
    },
    paramsType: "base64Array",
    theme: "dragNDrop",
    hideProgressBar: false,
    hideResetBtn: false,
    hideSelectBtn: false,
    hideUploadButton: true,
    hideExternalUploadButton: true,
    fileNameIndex: true,
    replaceTexts: {
      selectFileBtn: 'Seleziona il File',
      resetBtn: 'Reset',
      uploadBtn: 'Carica',
      dragNDropBox: 'TRASCINA QUI IL FILE',
      attachPinBtn: 'Attach Files...',
      afterUploadMsg_success: 'Successfully Uploaded !',
      afterUploadMsg_error: 'Upload Failed !',
      sizeLimit: 'Size Limit'
    }
  };
  typeSelected: string;
  constructor(
    private apiRest: ApiRestService,
    private adminApiRest: AdminApiRestService,
    private filestore: FileStoreService,
    private spedizioniStore: SpedizioniStoreService,
    private clientiStore: AziendeStoreService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private AuthenticationService: AuthenticationService,
    private downloadService: DownloadService,
    public permission: Permission,
    private toastservice: ToastrService,
    private spinnerService: NgxSpinnerService
  ) { this.typeSelected = 'ball-fussion';
    if(!this.Selected?.standby && this.Selected?.id && !(this.Selected?.corrieriObject?.length>0))
      this.spinnerService.show();
  }

  // public showSpinner(): void {
  //
  //
  //   setTimeout(() => {
  //     this.spinnerService.hide();
  //   }, 5000); // 5 seconds
  // }
  modificaColli: boolean;
  corriereManuale: boolean;
  preventivo: boolean;
   canDeleteFiles() {
    return !(this.Selected?.ldv?.length > 0) || this.permission.isOperativeRoles(['A', 'BM'])
  };


  Compile(data){
    this.filestore.SelectId(data.id);
    this.filestore.SetListaFile(data.files ?? []);
    this.filestore.updateSelectedUrl('/task/spedizione/file');
    this.filestore.SelectSection('spedizioni');
    data.creaCliente = false;
    this.Selected = data;

    if(!this.Selected.dataRitiroFiliale) {
      var date = new Date();
      if (date.getDay() == 5)
        date.setDate(date.getDate() + 3);
      else if (date.getDay() == 6)
        date.setDate(date.getDate() + 2);
      else
        date.setDate(date.getDate() + 1);
      this.Selected.dataRitiroFiliale = this.datePipe.transform(date, 'yyyy-MM-dd');
    }
    this.Selected.mittente = this.Selected.mittente ?? new Azienda();
    this.Selected.destinatario = this.Selected.destinatario ?? new Azienda();
    this.Selected.colli = this.Selected.colli ?? [];
    this.Selected.corrieriObject = data.corriereObject ? [data.corriereObject]: [];
    this.Selected.data_inizio_prevista = this.datePipe.transform(data.data_inizio_prevista, 'yyyy-MM-dd');
    if(!this.permission.isPermitted('scelta-mittente') && !this.Selected.id)
      this.mittenteuser(this.Selected)
    if(this.Selected.mittente && !this.Selected?.mittente?.country)
      this.Selected.mittente.country = "+39";
    if(this.Selected.destinatario && !this.Selected?.destinatario?.country)
      this.Selected.destinatario.country = "+39";
    this.Totale();
    if(!this.Selected?.standby && this.Selected?.id && !(this.Selected?.corrieriObject?.length>0))
    this.UpdateTariffe();
    this.modificaColli = this.Selected.tipoCollo == 'busta' || this.Selected.tipoCollo == 'pacco' || this.Selected.tipoCollo == 'pallet';
  }

  modificaCollichange(string: string){
    this.Selected.tipoCollo = string;
    this.modificaColli = this.Selected.tipoCollo == 'busta' || this.Selected.tipoCollo == 'pacco' || this.Selected.tipoCollo == 'pallet';
  }


  Refresh(){
    this.spedizioniStore.getCorrieri();
    this.route.params.subscribe(data => {
      var spedizione = data['spedizione'];
      this.preventivo = spedizione == 'preventivo'
      this.spedid =  !this.preventivo ? spedizione : undefined;
      if(this.spedid)
        this.apiRest.getSpedizione({id: parseInt(this.spedid)}).subscribe(data => this.Compile(data));
      else if (!this.preventivo)
        this.apiRest.getNextId().subscribe(data => this.Selected.progressivo = data);

    });
  }

  ngOnInit() {
    this.isAdmin = this.permission?.hasOperativeRole("A");
    this.isAgenziaMadre = this.permission?.isOperativeRole("AF");
    this.subscriptions.add(this.spedizioniStore.$corrieri.subscribe(data => {
      this.corrieri = data;
      if(!this.Selected?.standby && this.Selected?.id && !(this.Selected?.corrieriObject?.length>0))
      this.spinnerService.hide();
    }));
    this.subscriptions.add(this.clientiStore.$listaAziende.subscribe(data => this.clienti = data?.data));
    this.subscriptions.add(this.apiRest.getNazioni().subscribe(data => this.nazioni = data));
    this.Refresh();
  }

  mittenteuser(data){
    data.mittente = this.AuthenticationService.currentUserValue;
    data.mittente.nome = this.AuthenticationService.currentUserValue?.fullName;
    data.mittente.nazione = this.defaultNation;
    data.mittente.tel = this.AuthenticationService.currentUserValue?.telefono;
  }

  closeBtnClick() {
    this.spedizioniStore.updateEditable(false);
    this.spedizioniStore.updateAddable(false);
    this.router.navigate([this.route.snapshot.queryParams['spedizioni/lista'] || 'spedizioni/lista',]);
  }
  refreshinfo() {
    this.apiRest.getSpedizione(this.Selected).subscribe(data => this.Compile(data))
  }
  verificaIndirizzo(indirizzo: string, cap:string, citta:string , provincia:string){
    window.open("https://www.google.com/search?q=" +
      (indirizzo ?? '') + ' '
      + (cap ?? '') + ' '
      + (citta ?? '') +' '
      + (provincia ?? ''), "_blank");
  }
  saveClick() {
    this.costocorrierecamb(null)
    this.Selected.valoreAssicurazione = this.Selected.costoAssicurazione > 0 ?  this.Selected.valoreAssicurazione : null;
    this.Selected.valoreContrassegno = this.Selected.costoContrassegno > 0 ?  this.Selected.valoreContrassegno : null;
    if (this.Selected.corrieriObject && this.Selected.corrieriObject.length > 0)
      this.Selected.corriere = this.Selected.corrieriObject[0].id;
    else
      this.Selected.corriere = null;
    if (this.Selected.id && !isNaN(this.Selected.id)) {
      if(this.Selected.clienteObject)
        this.Selected.cliente = this.Selected?.clienteObject?.id;
      var tosave=Object.assign({}, this.Selected);
      if(!this.permission.isOperativeRoles(['A']))
        tosave.costoCorriere = undefined;
      this.apiRest.updateSpedizione(tosave).subscribe(() => this.closeBtnClick());
    } else {
      this.apiRest.addSpedizione(this.Selected).subscribe(() => {
        this.closeBtnClick();
        this.spedizioniStore.updateSpedizioneSelezionata(undefined);
      });
    }
  }
  CalcolaTariffePreventivo(){
    this.apiRest.tariffe(this.Selected).subscribe(data=> {
      this.tariffe = data.data;
      if(data?.message && data?.message!= "")
        this.toastservice.error(data.message);
    });
  }
  filtroCliente(item) {
    if (item?.length >= 3)
      this.clientiStore.getListaAziende(new RicercaPaginazione(item?.toString(), 0, 1));
  }

  clienteSelezionato(item) {
    this.adminApiRest.getInfoAziende(item).subscribe(data => {
      this.Selected.mittente = { nome: data.nominativo, indirizzo: data.indirizzo, cap: data.cap, citta: data.citta, provincia: data.provincia, nazione: [data.nazioneObject], tel: data.telefono, cf: data.cf, country: data.country };
      this.Selected.creaCliente = false;
      this.Selected.cliente = data.id;
    })
  }

  destinatarioSelezionato(item){
    this.adminApiRest.getInfoAziende(item).subscribe(data => {
      this.Selected.destinatario = { nome: data.nominativo, indirizzo: data.indirizzo, cap: data.cap, citta: data.citta, provincia: data.provincia, nazione: [data.nazioneObject], tel: data.telefono, cf: data.cf, country: data.country };
      this.Selected.creaDestinatario = false;
    })
  }

  Totale() {
    var value = this.Selected;
    return this.getFloatVal(value.costoSpedizione) +
      this.getFloatVal(value.costoContrassegno) +
      this.getFloatVal(value.costoAssicurazione) +
      this.getFloatVal(value.costoImballaggio) +
      this.getFloatVal(value.t10) +
      this.getFloatVal(value.t12) +
      this.getFloatVal(value.costoPreavTel) +
      this.getFloatVal(value.costoVarie) +
      this.getFloatVal(value.costoTriangolazione) +
      this.getFloatVal(value.costoDeposito) +
      this.getFloatVal(value.costoConsegnaPiano) +
      this.getFloatVal(value.costoRitiro);

  }
  getFloatVal(val){
    return !val ? 0 : (parseFloat(val?.toString()??'0')??0);
  }
  onFileChanged() {
    this.spedizioniStore.updateSpedizioneSelezionata(this.Selected);
  }

  costocorrierecamb(item){
   /* if(this.Selected.costoCorriere)
      this.Selected.costoAgenzia = this.Totale() - this.Selected.costoCorriere;*/
  }
  costolaeracamb(item){
    if(this.Selected.costoLaera)
      this.Selected.costoAgenzia = this.Totale() - this.Selected.costoLaera;
  }
  Print() {
    this.apiRest.stampa({id:this.Selected.id}).subscribe((data) => {
        this.downloadService.downloadFile(data, "riepilogo.docx");
      }
    );
  }
  PrintPreventivo(){
    this.apiRest.PrintPreventivo(Object.assign({}, this.Selected, {totale: this.Totale()})).subscribe((data) => {
        this.downloadService.downloadFile(data, `Preventivo_${this.Selected?.mittente?.nominativo ?? ""}.docx`);
      }
    );
  }

  // CreaLdv(id: number, tracking: number | string, data?,codice?, note?) {
  //   this.Selected.costoCorriere = this.tariffe.find(x=>x.id == tracking)?.valore;
  //   this.costocorrierecamb(null)
  //     // this.Selected.corriere = tracking;
  //   if(this.Selected.clienteObject)
  //     this.Selected.cliente = this.Selected?.clienteObject?.id;
  //   this.apiRest.updateSpedizione(this.Selected).subscribe(() => {
  //     this.apiRest.creaLDV({id: id, corriere: tracking, data: data, codice: codice, note: note}).subscribe(()=> this.refreshinfo())
  //   });
  // }
  CreaLdv(id: number, tariffa: any) {
    this.Selected.costoLaera = tariffa?.valore;
    this.costocorrierecamb(null)
    // this.Selected.corriere = tracking;
    if(this.Selected.clienteObject)
      this.Selected.cliente = this.Selected?.clienteObject?.id;
    this.apiRest.updateSpedizione(this.Selected).subscribe(() => {
      this.apiRest.creaLDV({id: id, corriere: tariffa.id, data: tariffa.data, codice: tariffa.dati, note: tariffa.note}).subscribe(()=> this.refreshinfo())
    });
  }


  collival( type: 'pt'|'pe'|'kg'| 'pe333'): number{
    var out: number =0;
    this.Selected?.colli?.forEach(element=> {
      if(element.pt && element.pt > 0 && type == 'pt')
        out = out + parseFloat(element.pt.toString());
      if(element.pe && element.pe > 0 && type == 'pe')
        out = out + parseFloat(element.pe.toString());
      if(type == 'pe333')
        out = out + (element.h * element.l * element.p)/3333;
      if(element.kg && element.kg > 0 && type == 'kg')
        out = out + parseFloat(element.kg.toString());
    })
    return out
  }

  UpdateTariffe() {
    this.apiRest.tariffe({id: this.Selected.id}).subscribe(data=> {
      this.tariffe = data.data;
      if(data?.message && data?.message!= "")
        this.toastservice.error(data.message);
    });
  }

  OnBase64FilesChange(event: { allegato: string; file: string; descrizione: string }[]) {
    this.Selected.allegato = event;
  }

  attenderechange() {
    if(!this.Selected?.standby && this.Selected?.id && !(this.Selected?.corrieriObject?.length>0))
      this.UpdateTariffe();
  }

  setNazionale(event) {
    this.Selected.internazionale = !event;
  }
  Tracking(spedizione: Spedizione) {
    var url = `tracking/${spedizione.id}`;
    this.router.navigate([this.route.snapshot.queryParams[url] || url])
  }

  getMargine() {
    if(this.Selected.costoLaera)
      this.Selected.costoAgenzia = this.Totale() - this.Selected.costoLaera;
    return this.Selected.costoAgenzia;
  }

  CreaRitiro() {
    this.apiRest.creaRitiro({id: this.Selected.id, data: this.Selected.dataRitiroFiliale}).subscribe(()=> this.refreshinfo());
  }
}
